import { useState } from "react";

import trash from "../../assets/images/73-delete.svg";
import setting from "../../assets/images/73-edit.svg";
import mouse from "../../assets/images/73-step-type1-selected.svg";
import mouseDisable from "../../assets/images/73-step-type1.svg";
import keybord from "../../assets/images/73-step-type2-selected.svg";
import keybordDisable from "../../assets/images/73-step-type2.svg";
import restore from "../../assets/images/73-undelete.svg";
import playActive from "../../assets/images/play-hover.svg";
import play from "../../assets/images/play.svg";

const StepListSingleItem = ({ id, src, isRemove, activeItem, effectType }) => {
  const [removed, setRemoved] = useState(isRemove);
  const [active, setActive] = useState(activeItem);

  return (
    <div className={`step-list-single-item ${active ? "active" : null} ${removed ? "disable" : null} `} style={{ backgroundImage: `url(${src})` }}>
      <div className="space-between">
        <div className="flex">
          <img alt="" src={effectType === "mouse" ? (removed ? mouseDisable : mouse) : removed ? keybordDisable : keybord} width={16} />
        </div>
        <div className="step-list-item-options">
          {removed ? (
            <img alt="" src={restore} onClick={() => setRemoved(!removed)} width={16} className="pointer" />
          ) : (
            <div className="flex">
              <img alt="" src={trash} className="pointer btn-remover" width={16} onClick={() => setRemoved(!removed)} />
              <img alt="" src={setting} className="pointer btn-edit" width={16} />
            </div>
          )}
        </div>
      </div>

      <div className={`justify-content-center ${removed ? "visibility-hidden" : null} `}>
        <img alt="" src={active ? playActive : play} width={36} className="btn btn-play" onClick={() => setActive(!active)} />
      </div>

      <div className="step-list-item-time"> {id} </div>
    </div>
  );
};

export default StepListSingleItem;
